import { InfoCircle } from '@upright/ui/icons';
import clsx from 'clsx';
import type { SVGProps } from 'react';
import styles from './InfoGlyph.module.css';

/**
 * The product's one "more information" icon, the ⓘ: the curated `InfoCircle`, drawn with a line
 * that stays about 1px at any size. Every info trigger draws this, whatever opens the
 * explanation (`InfoTooltip`, a `Popover`, a legacy tooltip wrapper), so the ⓘ looks the same
 * across the product. A question mark means "help", not "information about this item".
 *
 * Decorative by default (`aria-hidden`): the control around it carries the accessible name.
 * Size it with `width`/`height` (16px by default) or with CSS; colour it with `color`.
 *
 * It does not forward a ref (the generated `InfoCircle` accepts none), so a tooltip that anchors
 * on a ref to its child, such as Primer's `Tooltip` or React Aria's `Focusable`, needs it wrapped
 * in a span. Without one the page renders and the tooltip silently never opens.
 */
export function InfoGlyph({ className, width = 16, height = width, ...rest }: SVGProps<SVGSVGElement>) {
  return <InfoCircle aria-hidden {...rest} width={width} height={height} className={clsx(styles.root, className)} />;
}
